//* 插件
import { SetupContext, ref, shallowRef } from "vue";
//* 组件属性
import type { ModuleData, ModulePickerEmits } from "../../../src/types";
import { analyzes } from "../../../src/utils";

export const useComposable = (emits: SetupContext<typeof ModulePickerEmits>["emit"]) => {
    //* 响应式变量
    const refs = {
        end: ref<Date>(),
        date: ref<Date>(new Date()),
        start: ref<Date>(),
        months: shallowRef<number[]>([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
    };

    //* 函数列表
    const methods = {
        //* 更新函数
        date: (data: { year?: number; month?: number }) => emits("update", data),
        //* 初始化函数
        init: (data: ModuleData) => {
            //* 数据初始化
            refs.end.value = analyzes.date(data.end);
            refs.date.value = data.date;
            refs.start.value = analyzes.date(data.start);
        },

        //* 状态更新
        update: (date: Date) => (refs.date.value = date),
        //* 切换函数
        change: (number: number) => {
            emits("update", { month: number });
            emits("switchover", "auto");
        },

        //* 检测月份状态
        get_month_status: (month: number) => {
            //* 数据初始化
            const result: string[] = [];
            //* 检测日期是否被选中
            const currentYear = refs.date.value.getFullYear();
            const startMonth = refs.start.value?.getMonth();
            const startYear = refs.start.value?.getFullYear();
            const endMonth = refs.end.value?.getMonth();
            const endYear = refs.end.value?.getFullYear();
            if ((currentYear == startYear && startMonth == month) || (currentYear == endYear && endMonth == month)) result.push("ui-active");
            else if (startMonth != undefined && startYear != undefined && endMonth != undefined && endYear != undefined) {
                if (currentYear < endYear && currentYear > startYear) result.push("ui-contain-status");
                else if (currentYear == startYear && month >= startMonth) result.push("ui-contain-status");
                else if (currentYear == endYear && month <= endMonth) {
                    result.push("ui-contain-status");
                }
            }

            return result.join(" ");
        },
    };

    return { refs, methods };
};
